// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const representanteService = async (cotaUsuarioId: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/representante/cotausuario/${cotaUsuarioId}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      // Verifica se o `response.data` tem propriedades ou se não está vazio
      if (response.data && Object.keys(response.data).length > 0) {
        return response.data;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }
};
